import { format, isToday } from 'date-fns';

import type { Locale } from 'date-fns';

type FormatTimeOrDateTimeOptions = {
  locale?: Locale;
};

function formatTimeOrDateTime(dateString: Date | string, { locale }: FormatTimeOrDateTimeOptions = {}): string {
  return isToday(dateString) ? format(dateString, 'p', { locale }) : format(dateString, 'dd.MM p', { locale });
}

export { formatTimeOrDateTime };
